<template>
  <section class="v-pagination">
    <span class="total">Total: {{total}}</span>
    <el-pagination
      :background="background"
      layout="prev, pager, next, jumper"
      :page-size="pageSize"
      :total="total"
      :pager-count="pagerCount"
      :current-page.sync="currentPage"
      @current-change="currentChange"
    />
  </section>
</template>

<script>
export default {
  name: 'VPagination',
  props:{
    background: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 20
    },
    pagerCount: {
      type: Number,
      default: 7
    },
    total: {
      type: Number,
      default: 100
    },
    current: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      currentPage: 1
    }
  },
  watch: {
    current: {
      immediate: true,
      handler(val) {
        if(val !== this.currentPage) {
          this.currentPage = val
        }
      }
    }
  },
  methods: {
    currentChange(page) {
      this.$emit('currentChange', page)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  .total{
    font-size: 14px;
    font-weight: 600;
    margin-right: 8px;
  }
}
</style>